import React from 'react';
import { Menu, MenuItem, MenuButton, MenuButtonSize } from '../Menu/Menu';
import { MenuButton as BaseMenuButton } from '@mui/base';
import Icon from '../Icon/Icon';
import { Dropdown } from '@mui/base';
import { AnimatePresence, motion } from 'motion/react';
import Button from '../Button/Button';

export type Action = {
  label: string | React.ReactElement;
  disabled?: boolean;
  divider?: boolean;
  visible?: boolean;
  action?(): void;
  icon?: React.ReactElement | null;
};

type Props = {
  actions: Action[];
  button?: React.ComponentType;
  icon?: React.ReactElement;
  size?: MenuButtonSize;
};

const AnimatedMenuItem = motion.create(MenuItem);

const ActionSheet: React.FC<Props> = (props) => {
  const {
    actions,
    button = null,
    icon = <Icon name={'far fa-ellipsis-vertical'} />,
    size,
  } = props;

  const items = actions.filter(({ visible = true }) => visible);

  return (
    <>
      {button ? (
        <BaseMenuButton slots={{ root: button }} />
      ) : (
        <MenuButton size={size} startIcon={icon} />
      )}
      <AnimatePresence>
        <Menu data-testid="menu">
          {items.map(({ label, divider, disabled, action, icon }, index) => (
            <MenuItem
              key={index}
              divider={divider}
              disabled={disabled}
              onClick={disabled ? undefined : action}
              icon={icon}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      </AnimatePresence>
    </>
  );
};

const AddButton = React.forwardRef<HTMLButtonElement, any>(
  ({ ownerState, ...props }, ref) => (
    <Button
      {...props}
      ref={ref}
      variant="text-primary"
      size={'large'}
      startIcon={<Icon name="fa-regular fa-square-plus" />}
    />
  ),
);

const ActionSheetWithDropdown = (props: Props) => (
  <Dropdown>
    <ActionSheet {...props} />
  </Dropdown>
);

export default Object.assign(ActionSheetWithDropdown, {
  Buttons: {
    Add: AddButton,
  },
});
